import KeyStatsCardWithIcon from 'components/KeyStatsCardWithIcon/KeyStatsCardWithIcon';
import {
    faChartMixedUpCircleDollar, faHandHoldingDollar, faHandshake, faSearchDollar, faUsdCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { Col, Row } from 'reactstrap';
import { IAggregateReportKeyStats } from 'views/Reports/types';
import { numeralFormatterCurrency } from 'ns_libs/formatter';

export interface IAggregateReportKeyStatsProps {
    keyStats: IAggregateReportKeyStats;
}
const AggregateReportKeyStats = ({ keyStats }: IAggregateReportKeyStatsProps) => (
    <>
        <Row className="d-flex mt-2 mb-0 pb-0 justify-content-between">
            <Col xs="4" className="pr-0 pb-0 mb-0">
                <KeyStatsCardWithIcon
                    title="LEVERED IRR"
                    value={keyStats.leveredIrr || '-'}
                    isPercentage
                    icon={faChartMixedUpCircleDollar}
                    cardClassname="mb-2 mt-2"
                />
            </Col>
            <Col xs="4" className="pr-0 pb-0 mb-0">
                <KeyStatsCardWithIcon
                    title="LEVERED EMx"
                    value={keyStats.leveredEmx ? `${keyStats.leveredEmx.toFixed(2)}x` : '-'}
                    icon={faSearchDollar}
                    cardClassname="mb-2 mt-2"
                />
            </Col>
            <Col xs="4" className="pb-0 mb-0">
                <KeyStatsCardWithIcon
                    title="STABILIZED YIELD-ON-COST"
                    value={keyStats.stabilizedYieldOnCost || '-'}
                    isPercentage
                    icon={faHandHoldingDollar}
                    cardClassname="mb-2 mt-2"
                />
            </Col>
        </Row>
        <Row className="d-flex mt-0 pt-0 justify-content-between">
            <Col xs="4" className="pr-0 pt-0 mt-0">
                <KeyStatsCardWithIcon
                    title="EQUITY PROCEEDS"
                    value={numeralFormatterCurrency(keyStats.equityProceeds, '$0,0') || '-'}
                    icon={faUsdCircle}
                    cardClassname="mb-3"
                />
            </Col>
            <Col xs="4" className="pr-0">
                <KeyStatsCardWithIcon
                    title="GENERAL PARTNER IRR"
                    value={keyStats.generalPartnerIrr || '-'}
                    isPercentage
                    icon={faHandshake}
                    cardClassname="mb-3"
                />
            </Col>
            <Col xs="4">
                <KeyStatsCardWithIcon
                    title="LIMITED PARTNER IRR"
                    value={keyStats.limitedPartnerIrr || '-'}
                    icon={faHandshake}
                    isPercentage
                    cardClassname="mb-3"
                />
            </Col>
        </Row>
    </>
);

export default AggregateReportKeyStats;
